import _ from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import variant from '../flags_variants/variant'
import { canViewInvoices } from './capabilities/chargeCapabilities'
import { canViewUsersApp } from './capabilities/userAppCapabilities'
import { canViewReports } from './capabilities/reportCapabilities'
import { canManagePromotions } from './capabilities/promoCapabilities'
import { GlobalContext } from './GlobalContext'

const APP_NAME = process.env.REACT_APP_BUSINESS_NAME.toLowerCase()

const FlagProvider = ({ children }) => {
  const [isReady, setIsReady] = useState(false)

  const [data, setData] = useState({})
  const [shouldViewCoreInfo, setShouldViewCoreInfo] = useState(null)
  const [shouldViewTransactionInfo, setShouldViewTransactionInfo] = useState(null)
  const [shouldCreateOrder, setShouldCreateOrder] = useState(false)
  const [hasTenantReport, setTenantReport] = useState(false)
  const [redirectPath, setRedirectPath] = useState(false)
  const [hasAppEntrega, setHasAppEntrega] = useState(false)
  const [useAve, setUseAve] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const variants = await JSON.parse(JSON.stringify(variant))
      const lookup = _.keyBy(variants, (pr) => pr.clientName)
      const config = lookup[APP_NAME]

      setData(config)
      setShouldCreateOrder(config.shouldCreateOrder)
      setShouldViewCoreInfo(config.shouldViewCoreInfo)
      setShouldViewTransactionInfo(config.shouldViewTransactionInfo)
      setRedirectPath(config.redirectPath)
      setTenantReport(config.hasTenantReport)
      setHasAppEntrega(config.hasAppEntrega)
      setUseAve(config.useAve)

      setIsReady(true)
    }

    fetchData()
  }, [])

  const contextValue = useMemo(() => {
    if (!isReady) {
      return {
        variants: {},
        supervisorRole: true,
        shouldCreateOrder: false,
        shouldViewCoreInfo: null,
        shouldViewTransactionInfo: null,
        redirectPath: false,
        canMakePromoRole: false,
        hasAppEntrega: false,
        hasTenantReport: false,
        useAve: false,
        configPermission: false,
        canViewReport: false,
        isReady: false
      }
    }

    const supervisorRole = true
    const shouldViewCoreInfoByRole =
      shouldViewCoreInfo && supervisorRole && canViewInvoices()

    const canMakePromoRole = canManagePromotions()
    const redirectPathByRole = 'inicio'

    return {
      variants: data,
      supervisorRole,
      shouldCreateOrder,
      shouldViewCoreInfo: shouldViewCoreInfoByRole,
      shouldViewTransactionInfo,
      redirectPath: redirectPathByRole,
      canMakePromoRole,
      hasAppEntrega,
      hasTenantReport,
      useAve,
      configPermission: canViewUsersApp(),
      canViewReport: canViewReports(),
      isReady
    }
  }, [
    data,
    shouldCreateOrder,
    shouldViewCoreInfo,
    shouldViewTransactionInfo,
    hasAppEntrega,
    hasTenantReport,
    useAve,
    isReady
  ])

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  )
}

export default FlagProvider
